<template>
  <div :class="['section__cta', { '--top': marginTop }]">
    <h3 class="subtitle --margin" v-reveal="{ delay: 200 }">{{ content.title }}</h3>
    <p class="section__cta-description" v-reveal="{ delay: 250 }">{{ content.description }}</p>
    <ExternalLink
      :link="content.link"
      :label="content.label"
      class="--centered --top"
      v-reveal="{ delay: 300 }"
    />
  </div>
</template>

<script>
import { ExternalLink } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CTABlock',
  mixins: [DefaultSectionProps],
  props: {
    marginTop: {
      type: Boolean,
      default: true,
    },
  },
  components: { ExternalLink },
}
</script>
